import React from 'react';
import ExpenseListTable from '../expense/ExpenseListTable';
import ExpenseListGrid from '../expense/ExpenseListGrid';

const TripDetailView = ({ trip, members, expenses, userProfile, appUser, listViewMode, onBack, onEditTrip, onAddMember, onRemoveMember, onSummary, onToggleViewMode, onAddExpense, onEditExpense, onDeleteExpense, getPayerDisplay, getPaymentStyle }) => {
    return (
        <div style={{ paddingBottom: '80px' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px', gap: '10px' }}>
                <button onClick={onBack} className="icon-button" aria-label="กลับหน้ารายการ" title="กลับหน้ารายการ">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M15 18l-6-6 6-6"></path>
                    </svg>
                </button>
                <h2 style={{ margin: 0, color: 'var(--color-primary)', fontFamily: 'var(--font-display)' }}>{trip.icon || '✈️'} {trip.name}</h2>
                {trip.created_by === appUser.id && (
                    <button 
                        onClick={onEditTrip}
                        style={{ 
                            background: 'var(--color-glass-strong)', 
                            border: '1px solid var(--color-border)', 
                            borderRadius: '50%',
                            width: '32px',
                            height: '32px',
                            cursor: 'pointer', 
                            marginLeft: '6px', 
                            color: 'var(--color-text-muted)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 10px 20px rgba(30, 70, 90, 0.12)'
                        }}
                        title="แก้ไขชื่อทริป"
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                        </svg>
                    </button>
                )}
            </div>

            {/* Members */}
            <div style={{ marginBottom: '20px', overflowX: 'auto', whiteSpace: 'nowrap', paddingBottom: '10px' }}>
                <div style={{ display: 'inline-flex', gap: '10px' }}>
                    <button onClick={onAddMember} style={{ width: '50px', height: '50px', borderRadius: '50%', border: '2px dashed var(--color-primary)', background: 'var(--color-glass-strong)', color: 'var(--color-primary)', fontSize: '24px', cursor: 'pointer' }}>+</button>
                    {members.map(m => (
                        <div key={m.id} style={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => onRemoveMember(m)}>
                            {m.picture_url ? <img src={m.picture_url} alt="" style={{ width: '50px', height: '50px', borderRadius: '50%', border: '2px solid rgba(255, 255, 255, 0.9)', boxShadow: '0 10px 20px rgba(30, 70, 90, 0.12)' }} /> : <div style={{ width: '50px', height: '50px', borderRadius: '50%', backgroundColor: 'var(--color-surface-muted)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>👤</div>}
                            <div style={{ fontSize: '10px', marginTop: '4px', maxWidth: '60px', overflow: 'hidden', textOverflow: 'ellipsis', color: 'var(--color-text-subtle)' }}>{m.id === appUser.id ? 'ฉัน' : m.display_name}</div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Actions */}
            <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                <button 
                    onClick={onSummary} 
                    style={{ 
                        flex: 1, 
                        padding: '15px', 
                        backgroundColor: 'var(--color-primary)', 
                        backgroundImage: 'var(--color-primary-gradient)', 
                        color: 'white', 
                        border: 'none', 
                        borderRadius: '12px', 
                        fontWeight: 'bold', 
                        fontSize: '16px',
                        boxShadow: '0 4px 12px rgba(var(--color-primary-rgb), 0.3)',
                        cursor: 'pointer' 
                    }}
                >
                เคลียร์รายจ่ายทริป
                </button>
            </div>

            {/* Expenses */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                <div style={{ fontSize: '18px', fontWeight: 'bold', color: 'var(--color-primary)' }}>
                    รวม: {expenses.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0).toLocaleString()}
                </div>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button 
                        onClick={() => onToggleViewMode('grid')}
                        style={{
                            padding: '8px 12px',
                            borderRadius: '8px',
                            border: listViewMode === 'grid' ? '1px solid var(--color-primary)' : '1px solid var(--color-border)',
                            backgroundColor: listViewMode === 'grid' ? 'var(--color-primary-soft)' : 'var(--color-glass-strong)',
                            color: listViewMode === 'grid' ? 'var(--color-primary)' : 'var(--color-text-muted)',
                            cursor: 'pointer',
                            display: 'flex', alignItems: 'center', gap: '6px',
                            fontSize: '14px', fontWeight: '500'
                        }}
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                        Grid
                    </button>
                    <button 
                        onClick={() => onToggleViewMode('table')}
                        style={{
                            padding: '8px 12px',
                            borderRadius: '8px',
                            border: listViewMode === 'table' ? '1px solid var(--color-primary)' : '1px solid var(--color-border)',
                            backgroundColor: listViewMode === 'table' ? 'var(--color-primary-soft)' : 'var(--color-glass-strong)',
                            color: listViewMode === 'table' ? 'var(--color-primary)' : 'var(--color-text-muted)',
                            cursor: 'pointer',
                            display: 'flex', alignItems: 'center', gap: '6px',
                            fontSize: '14px', fontWeight: '500'
                        }}
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>
                        Table
                    </button>
                </div>
            </div>
            {expenses.length === 0 ? <p style={{ textAlign: 'center', color: 'var(--color-text-subtle)' }}>ยังไม่มีรายจ่าย</p> : (
                listViewMode === 'table' ? (
                    <ExpenseListTable 
                        expenses={expenses}
                        onEdit={onEditExpense}
                        onDelete={onDeleteExpense}
                        userProfile={userProfile}
                        getPayerDisplay={getPayerDisplay}
                        getPaymentStyle={getPaymentStyle}
                    />
                ) : (
                    <ExpenseListGrid 
                    expenses={expenses}
                    onEdit={onEditExpense}
                    onDelete={onDeleteExpense}
                    userProfile={userProfile}
                    getPayerDisplay={getPayerDisplay}
                    getPaymentStyle={getPaymentStyle}
                />
                )
            )}

            {/* Add Button */}
            <div style={{ position: 'fixed', bottom: '30px', left: 0, right: 0, display: 'flex', justifyContent: 'center', pointerEvents: 'none' }}>
                <button onClick={onAddExpense} style={{ pointerEvents: 'auto', padding: '16px 32px', backgroundColor: 'var(--color-primary)', backgroundImage: 'var(--color-primary-gradient)', color: 'white', border: 'none', borderRadius: '50px', fontSize: '18px', fontWeight: 'bold', boxShadow: '0 16px 30px rgba(var(--color-primary-rgb), 0.35)' }}>
                    + เพิ่มรายจ่ายทริป
                </button>
            </div>
        </div>
    );
};

export default TripDetailView;
